export const arr = [
  {
    name: null,
  },
  {
    name: 'R&Bbit',
    icon: require('@/assets/icon/users/animal_avatar-03.png/?esModule=false'),
    id: 1,
  },
  { name: 'Пати Р.', icon: require('@/assets/icon/users/animal_avatar-01.png/?esModule=false'), id: 2 },
  { name: 'Чиа', icon: require('@/assets/icon/users/animal_avatar-02.png/?esModule=false'), id: 3 },
  { name: 'Киса Кис', icon: require('@/assets/icon/users/animal_avatar-07.png/?esModule=false'), id: 4 },
  { name: 'Дэни Стар', icon: require('@/assets/icon/users/animal_avatar-04.png/?esModule=false'), id: 5 },
  { name: 'Кввоби', icon: require('@/assets/icon/users/animal_avatar-05.png/?esModule=false'), id: 12 },
  { name: 'BassCow', icon: require('@/assets/icon/users/animal_avatar-06.png/?esModule=false'), id: 123 },
]
export const ICON = {
  help: require('@/assets/icon/help.svg/?esModule=false'),
  cross: require('@/assets/icon/cross.svg/?esModule=false'),
  10: require('@/assets/icon/heart.svg/?esModule=false'),
  1: require('@/assets/icon/transparentHeart.svg/?esModule=false'),
  0: require('@/assets/icon/circle.svg/?esModule=false'),
  '-1': require('@/assets/icon/skip.svg/?esModule=false'),
  '-10': require('@/assets/icon/dislike.svg/?esModule=false'),
}
export const arrPopup0 = [
  { text: 'Задание: Проанализировать таблицу и определить, можно ли рекомендовать неизвестные мелодии Толе.', buttonTitle: 'Продолжить' },
]
export const arrPopup2 = [
  { text: 'Согласен. Мне тоже кажется, чему понравится!!.' },
]
export const arrPopup3 = [
  { text: 'Согласен. Мне тоже кажется, что рекомендовать эту песню Толе не нужно.' },
]
export const arrPopup4 = [
  { text: 'Проверь ещё раз.' },
]
export const arrPopupChooseUser = [
  { text: 'Ого, у Егора и Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню Егора.', buttonTitle: 'Продолжить' },
]
export const arrPopupChooseUserWrong = [
  { text: 'Не уверен, что этот этот профиль похож на профиль Толи. Посмотри внимательнее.' },
]
export const nextLesson = [
  { text: 'Отлично, следующее задание!', buttonTitle: 'Следующий урок' },
]
